import styled from "styled-components";
import rollImage from '../media/images/epdm_roll_tiff.png';
import {FaCheck} from "react-icons/fa";
import { Stream } from "@cloudflare/stream-react";



const Wrapper = styled.div`
    display: block;
    width: 100%;
    //border: 1px solid #c58e50;    
    margin-top: 100px;
    margin-bottom: 30px;
    background-color: white;
    padding-top: 50px;
    @media (max-width: 1600px) {
        margin-top: 10px;
        padding-top: 10px;
    }
`;

const TrainingWrapper = styled.div`
    display: inline-block;
    //border: 1px solid #c58e50;
    width: 68%;
    height: 650px;
    //padding-bottom: 40%;
    margin-left: 15%;
    position: relative;
    @media (max-width: 1600px) {
        height: 500px;
    }
    @media (max-width: 1400px) {
        height: 750px;
    }
    @media (max-width: 1200px) {
        height: 700px;
    }
    @media (max-width: 1000px) {
        height: 600px;
    }
    @media (max-width: 800px) {
        height: 500px;
    }
   
`;


const ImageTraining = styled.img`
    width: 30%;
    border-radius: 30px;
    position: absolute;
    top: 0;
    left: 0;
    @media (max-width: 1600px) {
        display: none;
    }
`;


const StyledHeader1 = styled.h1`
    color: #232323;
    font-family: "Roboto", "serif";
    font-size: 42px;
    font-weight: 900;
    position: absolute;
    top: 60px;
    left: 33%;
    @media (max-width: 1600px) {
        display: none;
    }
`;


const StyledGreenHeader = styled.h5`
    color: #35644c;
    font-family: "Roboto", "serif";
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 30px;
    left: 33%;
    @media (max-width: 1600px) {
        display: none;
    }
`;

const StyledLeftText = styled.h5`
    color: #232323;
    font-family: "Roboto", "serif";
    font-size: 14px;
    font-weight: 400;
    position: absolute;
    bottom: 130px;
    left: 0;
    width: 25%;
    height: 240px;
    @media (max-width: 1600px) {
        font-size: 12px;
        width: 22%;
        top: 100px;
    }
    @media (max-width: 1400px) {
        font-size: 14px;
        width: 100%;
        top: 0;
    }
`;

const SmallHeader = styled.span`
    color: #232323;
    font-family: "Roboto", "serif";
    font-size: 22px;
    font-weight: bold;
`;

const StyledGreenText = styled.div`
    color: white;
    background-color: #3d6c4d;
    font-family: "Roboto", "serif";
    font-size: 14px;
    font-weight: 400;
    position: absolute;
    bottom: 100px;
    right: 549px;
    width: 14%;
    height: 240px;
    //border-radius: 25px;
    padding: 35px;
    @media (max-width: 1600px) {
        top: 100px;
    }
    @media (max-width: 1400px) {
        display: none;
    }
`;

const StyledStreamHWrapper = styled.div`
    width: 550px;
    position: absolute;
    bottom: 100px;
    right: 0;
    @media (max-width: 1600px) {
        top: 100px;
    }
    @media (max-width: 1400px) {
        width: 100%;
        top: 200px;
    }
    @media (max-width: 1000px) {
        width: 100%;
        top: 200px;
    }
    @media (max-width: 800px) {
        width: 100%;
        top: 250px;
    }
    @media (max-width: 500px) {
        width: 100%;
        top: 400px;
    }
`;

const StyledStream = styled(Stream)`
    width: 100%;
`;


function TrainingVideo() {

    const videoIdOrSignedToken = "97aa1b477eecda18fbfe77684331039e";

    return (
        <Wrapper>
            <TrainingWrapper>
                <ImageTraining src={rollImage} alt={"EPDM Training Image"}/>
                <StyledGreenHeader>
                    ИНФОРМАЦИЯ
                </StyledGreenHeader>
                <StyledHeader1>
                    Повече за EPDM мембраните и приложението им
                </StyledHeader1>
                <StyledLeftText>
                    <SmallHeader>Какво е EPDM мембрана?</SmallHeader>
                    <br/>
                    <p>
                        EPDM не е като другите материали за покриви. Не само притежава изключителни качества, които го
                        правят уникален, но и нашите EPDM мембрани могат да бъдат поставени като цяло парче, без нужда
                        от съединяване.
                    </p>
                    <p>
                        Работата с EPDM мембрана от едно парче и различна от тази с други материали на ролки. Може да
                        разгледате всички стъпки, които са необходими за поставяннето й. Също може да прочетете други
                        съвети и какво да имате предвид, при различни метеорологични условия.
                    </p>

                    {/*<p>Научете повече</p>*/}
                </StyledLeftText>
                <StyledGreenText>
                    <p>Защо да изберете EPDM и а какво го различава от другите мембрани?</p>
                    <p><FaCheck/> Бърз монтаж</p>
                    <p><FaCheck/> Не се изискква горелка</p>
                    <p><FaCheck/> Над 50 години живот</p>
                    <p><FaCheck/> Издръжлив на UV и топлина</p>
                </StyledGreenText>
                <StyledStreamHWrapper>
                    <StyledStream controls src={videoIdOrSignedToken} />
                </StyledStreamHWrapper>
                {/*<StyledVideo>*/}
                {/*    /!*<source src={videoMp4} type="video/mp4"/>*!/*/}
                {/*    Your browser does not support HTML5 video.*/}
                {/*</StyledVideo>*/}
            </TrainingWrapper>
        </Wrapper>

    );
}

export default TrainingVideo;

